import React from 'react';

export const RuCommentsModal = {
  title: 'Comments',
  body: (
    <div>
      <p>Description of the tsunami runup including damage, deaths, and comments on the accuracy of the report.</p>
      <p>
        For example, if the user is interested in tsunami runups that include descriptions of effects to schools, enter the word
        {' '}
        <strong>school</strong>
        {' '}
        in the comments field.
      </p>
    </div>
  ),
};
